import { render, staticRenderFns } from "./NewWorker.vue?vue&type=template&id=f85576f8&scoped=true"
import script from "./NewWorker.vue?vue&type=script&lang=js"
export * from "./NewWorker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85576f8",
  null
  
)

export default component.exports